import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c1a4a6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import {defaultPopUpsInstanceIds, PopUpsStoreManager} from "@/lib/store/manager/popup/PopUpsStoreManager";


export default /*#__PURE__*/_defineComponent({
  name: 'MenuHeader',
  props: {
  headerText: String,
  mainIcon: {
    type: String,
    required: true,
  },
},
  setup(__props) {




const openUserManual = () => {
  PopUpsStoreManager.store.setPopUpStateVisibility({
    visibility: true,
    instanceId: defaultPopUpsInstanceIds.userManual
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.mainIcon,
        alt: "icon"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("h1", null, _toDisplayString(__props.headerText), 1),
    _createElementVNode("div", {
      class: "icon background-transition",
      onClick: openUserManual
    }, [
      _createElementVNode("img", {
        src: require('@/lib/assets/img/icons/question-mark.svg'),
        alt: "display the user manual"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})